export const API_EMOJI = "https://flagcdn.com/";
export const FASTYPE_VERSION = "Fastype - 2.0.0";
export const API_URL = process.env.REACT_APP_API_URL;
export const PASSWORD_MIN_LENGTH = 6;
export const LOGIN_MIN_LENGTH = 4;
export const LOGIN_MAX_LENGTH = 24;

export const WEBSOCKET_URL: `ws://${string}` = `ws${API_URL!.replace("http", "")}` as `ws://${string}`;
export const CLASSIC_DEFAULT_GAME_DURATION = 60;
export const RACE_DEFAULT_RUSH_WORDS = 20;
